import React from 'react';
import './style.css';
import VideoCard from "./VideoCard";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useSelector } from "react-redux";


const Videos = () => {
  const isProUser = useSelector((state) => state.user.isPro);

  const videoUrlList = [
    {
      videoUrl: "3862acac-8399-410e-8551-1e1f71108214/",
      title: "Being a Disciplined Driver",
      description: "Good driving habits for safe and responsible driving.",
      locked: false,
      type: "theory",
    },
    {
      videoUrl: "7c95f50b-4a6d-41db-8e1c-0d2ae0eeaeb7/",
      title: "How to Get Driving Practice from an Instructor",
      description: "our vehicle training sessions.",
      locked: false,
      type: "theory",
    },
    {
      videoUrl: isProUser ? "c826fcf9-eed7-4166-b909-3e7d59d04dab/" : "none",
      title: "Road Signs",
      description: isProUser
        ? "Essential road signs and how to understand their meanings."
        : "Locked Video",
      locked: isProUser ? false : true,
      type: "theory",
    },
    {
      videoUrl: isProUser ? "4f0a4f4e-4840-4f6d-a42f-b99c96cdd7ba/" : "none",
      title: "Command Signs",
      description: isProUser
        ? "Mandatory road signs and how to follow them correctly."
        : "Locked Video",
      locked: isProUser ? false : true,
      type: "theory",
    },
    {
      videoUrl: isProUser ? "c80154b8-4b49-4907-8926-62e1f3075807" : "none",
      title: "Warning Signs",
      description: isProUser
        ? "Common road warnings and how to identify them quickly."
        : "Locked Video",
      locked: isProUser ? false : true,
      type: "theory",
    },
    // {
    //   videoUrl: isProUser ? "df45303d-9945-4010-987e-43d385a556c0/" : "none",
    //   title: "Traffic Signs (Part 6)",
    //   description: isProUser
    //     ? "Rules, Courtesy, and Safe Practice"
    //     : "Locked Video",
    //   locked: isProUser ? false : true,
    //   type: "theory",
    // },
    // {
    //   videoUrl: isProUser ? "c34c933e-6f58-4084-99ef-ce5348537f2c/" : "none",
    //   title: "Traffic Signs (Part 7)",
    //   description: isProUser
    //     ? "Rules, Courtesy, and Safe Practices"
    //     : "Locked Video",
    //   locked: isProUser ? false : true,
    //   type: "theory",
    // },
    // {
    //   videoUrl: isProUser ? "1be84f44-eeb9-4361-ad3c-f67e16b9b927/" : "none",
    //   title: "Traffic Signs (Part 8)",
    //   description: isProUser
    //     ? "Rules, Courtesy, and Safe Practices"
    //     : "Locked Video",
    //   locked: isProUser ? false : true,
    //   type: "theory",
    // },
    // {
    //   videoUrl: isProUser ? "386aee9c-0595-4eaf-87ca-ab579c8ce635/" : "none",
    //   title: "Traffic Signs (Part 9)",
    //   description: isProUser
    //     ? "Rules, Courtesy, and Safe Practices"
    //     : "Locked Video",
    //   locked: isProUser ? false : true,
    //   type: "theory",
    // },
    {
      videoUrl: isProUser ? "6c1f6fd4-1c6b-4134-97a5-bfb837030197/" : "none",
      title: "Driver Training Guide",
      description: isProUser ? "After get learner permit" : "Locked Video",
      locked: isProUser ? false : true,
      type: "practical",
    },
    {
      videoUrl: isProUser ? "1fcb885d-8f82-4c83-aaf8-e8b8f78fd126/" : "none",
      title: "How to Drive a Vehicle – Introduction",
      description: isProUser
        ? "learning with guidance from a professional instructor."
        : "Locked Video",
      locked: isProUser ? false : true,
      type: "practical",
    },
    {
      videoUrl: isProUser ? "5c0c603e-0d6d-4baa-92ef-469f86814e5f/" : "none",
      title: "How to Check a Vehicle Before Driving",
      description: isProUser
        ? "Key pre-drive checks including tires, oil, water, and overall vehicle safety."
        : "Locked Video",
      locked: isProUser ? false : true,
      type: "practical",
    },
    {
      videoUrl: isProUser ? "6288d0fb-d03d-4460-b1bb-c6a8d9daedd7/" : "none",
      title: "How to Drive a Vehicle – Part 1",
      description: isProUser
        ? "Essential steps and basics every learner must know before driving."
        : "Locked Video",
      locked: isProUser ? false : true,
      type: "practical",
    },
    {
      videoUrl: isProUser ? "8beb1a05-8392-4777-b526-e18ba9a9c6cd/" : "none",
      title: "How to Drive a Vehicle – Part 2",
      description: isProUser
        ? "Step-by-step guide to starting, maneuvering, and parking your vehicle safely."
        : "Locked Video",
      locked: isProUser ? false : true,
      type: "practical",
    },
    {
      videoUrl: isProUser ? "becec034-e419-4f1e-b771-ca18dc67fb17/" : "none",
      title: "How to Drive a Vehicle – Part 3",
      description: isProUser
        ? "Techniques for turning your vehicle safely and confidently on the road."
        : "Locked Video",
      locked: isProUser ? false : true,
      type: "practical",
    },
    {
      videoUrl: isProUser ? "745b31e6-9605-49cf-b153-62e360a6da36/" : "none",
      title: "How to Drive a Vehicle – Part 4",
      description: isProUser
        ? "Learn gear control, clutch balance, and proper use of vehicle lights."
        : "Locked Video",
      locked: isProUser ? false : true,
      type: "practical",
    },
  ];

  // 🔹 Filter by type
  const theoryVideos = videoUrlList.filter((video) => video.type === "theory");

  const practicalVideos = videoUrlList.filter(
    (video) => video.type === "practical",
  );

  return (
    <div className="container">
      {/* ================= THEORY SECTION ================= */}
      <h3 className="section-title mt-4 mb-3">Videos for Exam</h3>
      <Row>
        {theoryVideos.map((video, index) => (
          <Col lg={3} key={index}>
            <VideoCard
              title={video.title}
              description={video.description}
              videoUrl={video.videoUrl}
              locked={video.locked}
            />
          </Col>
        ))}
      </Row>

      {/* ================= PRACTICAL SECTION ================= */}
      <h3 className="section-title mt-5 mb-3">Videos Driving Test</h3>
      <Row>
        {practicalVideos.map((video, index) => (
          <Col lg={3} key={index}>
            <VideoCard
              title={video.title}
              description={video.description}
              videoUrl={video.videoUrl}
              locked={video.locked}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Videos;
